import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ProcessRoleList from './ProcessRoleList';
import ProcessRoleForm from './ProcessRoleForm';

const ProcessRoleRoutes = () => {
  return (
    <Routes>
      <Route index element={<ProcessRoleList />} />
      <Route path="new" element={<ProcessRoleForm />} />
      <Route path="edit/:id" element={<ProcessRoleForm />} />
    </Routes>
  );
};

export default ProcessRoleRoutes; 